module.exports = __webpack_public_path__ + "img/project-timeline.485dfe37.svg";